module.exports = __webpack_public_path__ + "static/media/Delete-playlist-icon.e5d5e0e0.svg";